import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-agendaItem-report-folder.controller';
import directive from './attach-agendaItem-report-folder.directive';


export default angular.module('app.components.advisory.oversight.attachAgendaItemReportFolder', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('attachAgendaItemReportFolder', directive)
  .controller('AttachAgendaItemReportFolderController', controller)
  .name;

console.log('app.components.advisory.oversight.attachAgendaItemReportFolder created');
